module.exports = __webpack_public_path__ + "media/images/pages/img_culture_event_02-e99da9b1e1d5d4bfcd86286eb0a1baa0.jpg";